import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import ProviderManager from '../provider/providerManager';
import EpiContext from '@episerver/spa-core/Spa';
const reportMiddleware = (store) => (next) => (action) => {
  if (action === undefined) {
    return;
  }

  try {
    let reportParams = {};
    const state = store.getState();
    let loginType = '';
    if (state.authentication?.loginData?.isOtpAuthenticated) {
      loginType = 'OTP';
    }
    if (state.authentication?.loginData?.isOtpExtendedAuthenticated) {
      loginType = 'OTP מורחב';
    }
    if (state.authentication?.loginData?.isFullAuthenticated) {
      loginType = 'לקוח';
    }
    switch (action.type) {
      case 'saleBlock/initSale':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(action.payload.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'New Sale';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'start new sale';
        report(reportParams);
        break;

      case 'saleBlock/setFlowType':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Flow Type';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set flow type to ' + action.payload.flowType;

        reportParams.param1 = action.payload.flowType;
        report(reportParams);
        break;

      case 'saleBlock/setLoginData':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Login Data';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'user logged in';
        reportParams.customerName = action.payload.firstName ? action.payload.firstName + ' ' + action.payload.lastName : '';
        reportParams.idNumber = action.payload.id;
        reportParams.subscriber = action.payload.contactNumber;

        reportParams.param1 = state.saleBlock.flowType;
        report(reportParams);
        break;

      case 'saleBlock/reportSetSelectedProducts':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Selected Products';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set selected products';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        report(reportParams);
        break;

      case 'saleBlock/setSelectedAddress':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Selected Address';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set selected address';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          action.payload.selectedAddress.cityName +
          ' ' +
          action.payload.selectedAddress.streetName +
          ' ' +
          action.payload.selectedAddress.home;
        reportParams.param8 = action.payload.selectedAddress.zipCode;
        report(reportParams);
        break;

      case 'saleBlock/setTechnicianArrivalTime':
      case 'saleBlock/setTechnicianArrivalTimeIbc':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Technician Arrival Time';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set technician arrival time';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          state.saleBlock.selectedAddress.cityName +
          ' ' +
          state.saleBlock.selectedAddress.streetName +
          ' ' +
          state.saleBlock.selectedAddress.home;
        reportParams.param6 = action.payload.technicianArrivalTime.arrivalTime;
        reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
        report(reportParams);
        break;

      case 'saleBlock/setSetupDeliveries':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Setup Deliveries';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set setup deliveries';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          state.saleBlock.selectedAddress.cityName +
          ' ' +
          state.saleBlock.selectedAddress.streetName +
          ' ' +
          state.saleBlock.selectedAddress.home;
        reportParams.param6 = action.payload.setupDeliveries.deliveryTime;
        reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
        report(reportParams);
        break;

      case 'saleBlock/setCustomerEmail':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Customer Email';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set customer email';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = action.payload.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          state.saleBlock.selectedAddress.cityName +
          ' ' +
          state.saleBlock.selectedAddress.streetName +
          ' ' +
          state.saleBlock.selectedAddress.home;
        reportParams.param6 = state.saleBlock.setupDeliveries.deliveryTime;
        reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
        report(reportParams);
        break;

      case 'saleBlock/setOtpCode':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Otp Code';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set otp code';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          state.saleBlock.selectedAddress.cityName +
          ' ' +
          state.saleBlock.selectedAddress.streetName +
          ' ' +
          state.saleBlock.selectedAddress.home;
        reportParams.param6 = state.saleBlock.setupDeliveries.deliveryTime;
        reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
        report(reportParams);
        break;

      case 'saleBlock/setPersonalInfo':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Personal Info';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set personal info';
        reportParams.customerName = action.payload.personalInfo.firstName
          ? action.payload.personalInfo.firstName + ' ' + action.payload.personalInfo.lastName
          : '';
        reportParams.email = action.payload.personalInfo.email;
        reportParams.idNumber = action.payload.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          state.saleBlock.selectedAddress.cityName +
          ' ' +
          state.saleBlock.selectedAddress.streetName +
          ' ' +
          state.saleBlock.selectedAddress.home;
        reportParams.param6 = state.saleBlock.setupDeliveries.deliveryTime;
        reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
        report(reportParams);
        break;

      case 'saleBlock/reportAddressNotConnectedToFiber':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Address Not Connected To Fiber';
        reportParams.status = 'Completed';
        reportParams.messageText = 'address not connected to fiber';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;

        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 = action.payload.address.cityName + ' ' + action.payload.address.streetName + ' ' + action.payload.address.home;
        reportParams.param6 = state.saleBlock.setupDeliveries.deliveryTime;
        reportParams.param8 = action.payload.address.zipCode;
        report(reportParams);
        break;

      case 'saleBlock/setIsMeshUpgrade':
        if (action.payload == true) {
          reportParams = getReportParams();
          reportParams.area = 'Sale';
          reportParams.subArea = getSaleType(state.saleBlock.saleType);
          reportParams.channel = 'Website';
          reportParams.actionType = 'Set Mesh Upgrade';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'set mesh upgrade';
          reportParams.customerName = state.saleBlock.personalInfo.firstName
            ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
            : '';
          reportParams.email = state.saleBlock.personalInfo.email;
          reportParams.idNumber = state.saleBlock.personalInfo.id;
          reportParams.subscriber = state.saleBlock.otpPhone;

          reportParams.param1 = state.saleBlock.flowType;
          reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
          reportParams.param3 = state.saleBlock.totalPrice.toString();
          reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
          reportParams.param5 =
            state.saleBlock.selectedAddress.cityName +
            ' ' +
            state.saleBlock.selectedAddress.streetName +
            ' ' +
            state.saleBlock.selectedAddress.home;
          reportParams.param6 = state.saleBlock.setupDeliveries.deliveryTime;
          reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
          report(reportParams);
        }
        break;

      case 'saleBlock/setPayment':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Payment';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'set payment';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;
        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          state.saleBlock.selectedAddress.cityName +
          ' ' +
          state.saleBlock.selectedAddress.streetName +
          ' ' +
          state.saleBlock.selectedAddress.home;
        reportParams.param6 = state.saleBlock.setupDeliveries.deliveryTime;
        reportParams.param7 = action.payload.payment.userName + ' ' + action.payload.payment.id;
        reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
        report(reportParams);
        break;

      case 'disconnectClientService/setServiceToDisconnect':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Disconnect';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = 'choose service to disconnect';
        reportParams.status = 'Completed';
        reportParams.messageText = 'choose service to disconnect';
        reportParams.customerName = `{state.authentication?.loginData?.userDetails?.firstName} {state.authentication?.loginData?.userDetails?.lastName}`;
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
        reportParams.subscriber = reportParams.param1 = state.disconnectServicesBlock.serviceToDisconnect.serviceType; // subscriber login
        reportParams.param2 = state.disconnectServicesBlock.serviceToDisconnect.title;
        report(reportParams);
        break;

      case 'saleBlock/goToPage':
        if (state.saleBlock.page == 'extraPage') {
          reportParams = getReportParams();
          reportParams.area = 'Sale';
          reportParams.subArea = getSaleType(state.saleBlock.saleType);
          reportParams.channel = 'Website';
          reportParams.actionType = 'Select Vas';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'Select Vas';
          reportParams.customerName = state.saleBlock.personalInfo.firstName
            ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
            : '';
          reportParams.email = state.saleBlock.personalInfo.email;
          reportParams.idNumber = state.saleBlock.personalInfo.id;
          reportParams.subscriber = state.saleBlock.otpPhone;

          reportParams.param1 = state.saleBlock.flowType;
          reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
          reportParams.param3 = state.saleBlock.totalPrice.toString();

          if (state.saleBlock.saleType == 'cellular') {
            let products = [];
            state.saleBlock.productsInfo.selectedProducts.forEach(function (product) {
              let vasList = product.vasList?.filter((x) => product.selectedVasList?.includes(x.id));
              if (vasList != null && vasList.length > 0) {
                products.push(vasList.map((x) => x.title)?.join(', '));
              }
            });
            reportParams.param4 = products.length > 0 ? products.join(' | ') : '';
          } else {
            reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
          }

          report(reportParams);
        }
        break;

      case 'saleBlock/setCellularPackage':
        const selectedProduct = state.saleBlock.productsInfo.productsForUpgrade.find((x) => x.productId == action.payload);
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Set Cellular Package';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'Set Cellular Package';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;
        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = selectedProduct.name;
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        report(reportParams);
        break;

      case 'choseNewOrExistingCellNum/getPhoneNumbers/fulfilled':
        if (action.payload.prettyPhoneNumbersList?.length > 0) {
          reportParams = getReportParams();
          reportParams.area = 'Sale';
          reportParams.subArea = getSaleType(state.saleBlock.saleType);
          reportParams.channel = 'Website';
          reportParams.actionType = 'Gold Number Displayed';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'Gold Number Displayed';
          reportParams.customerName = state.saleBlock.personalInfo.firstName
            ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
            : '';
          reportParams.email = state.saleBlock.personalInfo.email;
          reportParams.idNumber = state.saleBlock.personalInfo.id;
          reportParams.subscriber = state.saleBlock.otpPhone;
          reportParams.param1 = state.saleBlock.flowType;
          reportParams.param2 = '';
          reportParams.param3 = state.saleBlock.totalPrice.toString();
          reportParams.param9 = action.payload.prettyPhoneNumbersList[0];
          report(reportParams);
        }
        break;

      case 'choseNewOrExistingCellNum/setSelectedPhone':
        if (action.payload.isPrettyNum && state.choseNewOrExistingCellNum.form.selectedPhone != action.payload.selectedPhone) {
          reportParams = getReportParams();
          reportParams.area = 'Sale';
          reportParams.subArea = getSaleType(state.saleBlock.saleType);
          reportParams.channel = 'Website';
          reportParams.actionType = 'Chose Gold Number';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'Chose Gold Number';
          reportParams.customerName = state.saleBlock.personalInfo.firstName
            ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
            : '';
          reportParams.email = state.saleBlock.personalInfo.email;
          reportParams.idNumber = state.saleBlock.personalInfo.id;
          reportParams.subscriber = state.saleBlock.otpPhone;
          reportParams.param1 = state.saleBlock.flowType;
          reportParams.param2 = '';
          reportParams.param3 = state.saleBlock.totalPrice.toString();
          reportParams.param9 = action.payload.selectedPhone;
          report(reportParams);
        }
        break;

      case 'saleBlock/displayProductVas':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'Display VAS Page';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'Display VAS Page';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;
        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = '';
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param9 = '';
        report(reportParams);
        break;

      case 'saleBlock/selectProductVas':
        if (action.payload.isSelected) {
          reportParams = getReportParams();
          reportParams.area = 'Sale';
          reportParams.subArea = getSaleType(state.saleBlock.saleType);
          reportParams.channel = 'Website';
          reportParams.actionType = 'Add VAS';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'Add VAS';
          reportParams.customerName = state.saleBlock.personalInfo.firstName
            ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
            : '';
          reportParams.email = state.saleBlock.personalInfo.email;
          reportParams.idNumber = state.saleBlock.personalInfo.id;
          reportParams.subscriber = state.saleBlock.otpPhone;
          reportParams.param1 = state.saleBlock.flowType;
          reportParams.param2 = '';
          reportParams.param3 = state.saleBlock.totalPrice.toString();
          reportParams.param9 = '';
          reportParams.param10 = action.payload.title;
          report(reportParams);
        }
        break;

      case 'cellularSurfingUseDetailsBlock/openPopUpExpanding':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'גלישה';
        reportParams.channel = 'Website Private';
        reportParams.actionType = 'הצעה להרחבת גלישה';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'הצעה להרחבת גלישה';
        report(reportParams);
        break;

      case 'extendedLeadBlock/report': {
        switch (action.payload.type) {
          case 'addressNotConnectedToFiber':
            reportParams = getReportParams();
            reportParams.area = 'Sale';
            reportParams.subArea = 'Fiber';
            reportParams.channel = 'Website';
            reportParams.actionType = 'Address Not Connected To Fiber';
            reportParams.status = 'Completed';
            reportParams.messageText = 'customer created a work order about address not connected to fiber';
            reportParams.customerName = action.payload.form.firstName ?? '' + ' ' + action.payload.form.lastName ?? '';
            reportParams.subscriber = action.payload.form.phoneNumber;
            reportParams.email = action.payload.form.emailAddress;
            reportParams.param1 = action.payload.ticketNumber;
            reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ') ?? '';
            reportParams.param3 = state.saleBlock.totalPrice?.toString();
            reportParams.param5 =
              action.payload.additionalParams?.address?.cityName +
              ' ' +
              action.payload.additionalParams?.address?.streetName +
              ' ' +
              action.payload.additionalParams?.address?.home;
            reportParams.param8 = action.payload.additionalParams?.address?.zipCode;
            report(reportParams);
            break;
        }
        break;
      }

      case 'leadBlock/report': {
        switch (action.payload.type) {
          case 'addressNotConnectedToFiber':
            reportParams = getReportParams();
            reportParams.area = 'Sale';
            reportParams.subArea = 'Fiber';
            reportParams.channel = 'Website';
            reportParams.actionType = 'Address Not Connected To Fiber';
            reportParams.status = 'Completed';
            reportParams.messageText = 'customer created a hot lead about address not connected to fiber';
            reportParams.customerName = action.payload.leadForm?.fullName;
            reportParams.subscriber = action.payload.leadForm?.phone;
            reportParams.param5 = action.payload.fiberAddress;
            reportParams.param8 = action.payload.zipCode;
            report(reportParams);
            break;
        }
        break;
      }

      //------------------- CellcomEnergy -------------------
      case 'cellcomEnergyBlock/checkCellcomEnergy/fulfilled':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = 'CellcomEnergy';
        reportParams.channel = 'Website';
        reportParams.actionType = 'CellcomEnergyCheck';
        reportParams.status = 'Ongoing';
        reportParams.messageText = state.cellcomEnergyBlock.hasCellcomEnergy ? 'ניתן לנייד את הלקוח' : 'לא ניתן לנייד את הלקוח';
        reportParams.param5 =
          state.cellcomEnergyBlock.selectedAddress.cityName +
          ' ' +
          state.cellcomEnergyBlock.selectedAddress.streetName +
          ' ' +
          state.cellcomEnergyBlock.selectedAddress.houseNum;
        report(reportParams);
        break;
      case 'cellcomEnergyBlock/openWorkOrder/fulfilled':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = 'CellcomEnergy';
        reportParams.channel = 'Website';
        reportParams.actionType = 'CellcomEnergyOpenWorkOrder';
        reportParams.status = 'Completed';
        reportParams.messageText = action.payload.isSuccess ? 'הוראת עבודה נפתחה בהצלחה' : 'פתיחת הוראת עבודה נכשלה';
        reportParams.customerName = action.payload.leadData.firstName
          ? action.payload.leadData.firstName + ' ' + action.payload.leadData.lastName
          : '';
        reportParams.email = action.payload.leadData.email;
        reportParams.subscriber = action.payload.leadData.phone;
        reportParams.param5 =
          state.cellcomEnergyBlock.selectedAddress.cityName +
          ' ' +
          state.cellcomEnergyBlock.selectedAddress.streetName +
          ' ' +
          state.cellcomEnergyBlock.selectedAddress.houseNum;
        report(reportParams);
        break;
      //------------------- CellcomEnergy -------------------
      case 'saleBlock/createOtpForNewCustomerAsync/fulfilled':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(state.saleBlock.saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = 'New Customer Otp';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'Create Otp For New Customer';
        reportParams.customerName = state.saleBlock.personalInfo.firstName
          ? state.saleBlock.personalInfo.firstName + ' ' + state.saleBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleBlock.personalInfo.email;
        reportParams.idNumber = state.saleBlock.personalInfo.id;
        reportParams.subscriber = state.saleBlock.otpPhone;
        reportParams.param1 = state.saleBlock.flowType;
        reportParams.param2 = state.saleBlock.productsInfo?.selectedProducts?.map((x) => x.name)?.join(', ');
        reportParams.param3 = state.saleBlock.totalPrice.toString();
        reportParams.param4 = state.saleBlock.vasList?.map((x) => x.title)?.join(', ');
        reportParams.param5 =
          state.saleBlock.selectedAddress.cityName +
          ' ' +
          state.saleBlock.selectedAddress.streetName +
          ' ' +
          state.saleBlock.selectedAddress.home;
        reportParams.param8 = state.saleBlock.selectedAddress.zipCode;
        report(reportParams);
        break;
      //------------------- Abroad -------------------
      case 'cellcomAbroad/fetchPackageBusinessIndividualClient/fulfilled':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Cellcom Abroad';
        reportParams.channel = 'WebsiteBusiness';
        reportParams.actionType = 'Package search activation ';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'Package search activation ';
        reportParams.subscriber = '';
        reportParams.param1 = 'WEBSITE';
        reportParams.param3 = 'Individual';
        reportParams.param5 = state.cellcomAbroad.selectedCountries?.map((country) => country.countryCode).join(',');
        reportParams.param6 = state.cellcomAbroad.dates?.selectedStartDate;
        reportParams.param7 = state.cellcomAbroad.dates?.selectedEndDate;
        report(reportParams);
        break;
      case 'technicianUpdatesBlock/reportDWH':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Technician';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.statusText;
        reportParams.messageText = action.payload.messageText;
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
        reportParams.customerName = state.technicianUpdatesBlock.selectedVisit.contactName;
        reportParams.cmrId = state.technicianUpdatesBlock.selectedVisit.jetID;
        reportParams.psId = state.technicianUpdatesBlock.selectedVisit.psID;
        reportParams.param1 = state.technicianUpdatesBlock.selectedVisit.serviceTypeReport;
        reportParams.param2 = state.technicianUpdatesBlock.selectedVisit.technicianTypeReport;
        report(reportParams);
        break;
      case 'checkFiberInfrastructureBlock/checkFiberReport':
        let actionType = action.payload.hasFiber ? 'Address Connected To Fiber' : 'Address Not Connected To Fiber';
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = 'Fiber';
        reportParams.channel = 'Website';
        reportParams.actionType = actionType;
        reportParams.status = 'Completed';
        reportParams.messageText = actionType;
        reportParams.param5 =
          state.checkFiberInfrastructureBlock.form.cityName +
          ' ' +
          state.checkFiberInfrastructureBlock.form.streetName +
          ' ' +
          state.checkFiberInfrastructureBlock.form.home;
        reportParams.param8 = state.checkFiberInfrastructureBlock.form.zipCode;
        report(reportParams);
        break;
      case 'standAlonePurchaseSaleBlock/reportDWH':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'One Charge Equipment Order';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.statusText;
        reportParams.messageText = action.payload.messageText;
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
        reportParams.customerName =
          state.authentication?.loginData?.userDetails?.firstName + ' ' + state.authentication?.loginData?.userDetails?.lastName;
        reportParams.param1 = action.payload.param1 ?? '';
        reportParams.param2 = state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseTitle?.value ?? '';
        reportParams.param3 = action.payload.param3 ?? '';
        report(reportParams);
        break;

      case 'saleJetBlock/reportDWH':
        const hasEquipment = hasProducts(state.saleJetBlock) || state.SalePackagesBlock.selectedPackage?.isSelectedCellcomRouter;
        const premiumPackages = getPremiumPackages(state.saleJetBlock);
        const ban = state.saleJetBlock.userAddressPage.selectedAddress?.additionalInfo?.banId;
        const converters = state.saleJetBlock.saleCatalog.converters
          ? state.saleJetBlock.saleCatalog.converters.filter((x) => x.action == 'Add')
          : [];
        const selectedEntry = state.saleJetBlock.addressPage?.selectedEntry?.entry ?? '';
        const wifiRouter = state.saleJetBlock.saleCatalog.routers?.find(
          (router) => router.action == 'Add' && router.name === state.saleJetBlock.selectedPackage.routerInfo.nameRouterUpgrade.value,
        );
        let banOrNewAccount = '';
        // if (Object.keys(state.saleJetBlock.userAddressPage.selectedAddress).length > 0) {
        //     banOrNewAccount = state.saleJetBlock.userAddressPage.selectedAddress.additionalInfo?.banId;
        // }
        if (state.saleJetBlock.flowType === 'existsCustomer') {
          banOrNewAccount = 'EXISTING CUSTOMER';
        } else {
          banOrNewAccount = 'NEW ACCOUNT';
        }
        const saleJetType = getSaleType(state.saleJetBlock.saleType);

        let param2 = null;
        let param4 = null;
        let param5 = null;
        let param10 = null;
        if (saleJetType == 'Cellular') {
          param2 = state.saleJetBlock.cellular.cellularSettingsList?.map((x) => x.phoneNumber)?.toString();
          param4 = state.saleJetBlock.cellular.cellularSettingsList?.map((x) => x.package.offerId)?.toString();
          param5 = state.saleJetBlock.cellular.cellularSettingsList?.map((x) => x.simType)?.toString();
          let addons = [];
          state.saleJetBlock.cellular.cellularSettingsList.map((item) => {
            let selectedAddOns = [];
            item.selectedAddOns?.map((addon) => {
              selectedAddOns.push(addon.name);
            });
            addons.push(selectedAddOns);
          });
          param10 = addons.toString();
        } else {
          param2 = hasEquipment ? 'WITH EQUIPMENT' : 'WITHOUT EQUIPMENT';
          param4 =
            Object.keys(state.saleJetBlock.addressPage.selectedAddress).length > 0
              ? state.saleJetBlock.addressPage.selectedAddress.cityName +
                ' , ' +
                state.saleJetBlock.addressPage.selectedAddress.streetName +
                ' ' +
                state.saleJetBlock.addressPage.selectedAddress.home +
                (selectedEntry != '' ? ', כניסה: ' + selectedEntry : '') +
                ' ,דירה ' +
                state.saleJetBlock.addressPage.selectedAddress.apartment +
                ' ,מיקוד ' +
                state.saleJetBlock.addressPage.selectedAddress.zipCode
              : '';
          param5 = state.saleJetBlock.personalInfo.subscriberNo;
          param10 = state.saleJetBlock.personalInfo.isReceivingAd ? 'SHATAP ON' : 'SHATAP OFF';
        }
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = saleJetType;
        reportParams.channel = 'Website';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName = state.saleJetBlock.personalInfo.firstName
          ? state.saleJetBlock.personalInfo.firstName + ' ' + state.saleJetBlock.personalInfo.lastName
          : '';
        reportParams.email = state.saleJetBlock.personalInfo.email;
        reportParams.idNumber = state.saleJetBlock.personalInfo.identity;
        reportParams.subscriber = state.saleJetBlock.personalInfo.subscriberNo;

        reportParams.param1 = state.saleJetBlock.selectedPackage?.offerId;
        reportParams.param2 = param2;
        reportParams.param3 = state.saleJetBlock.flowType == 'newCustomer' ? 'NEW CUSTOMER' : 'EXISTING CUSTOMER';
        reportParams.param4 = param4;
        reportParams.param5 = param5;
        reportParams.param6 = banOrNewAccount;
        reportParams.param7 = premiumPackages;
        reportParams.param8 = wifiRouter ? wifiRouter.name : '';
        reportParams.param9 = state.saleJetBlock.saleCatalog.addons
          ? state.saleJetBlock.saleCatalog.addons
              .flatMap((x) => {
                if (x.action === 'Add') {
                  const selectedAddOns = state.saleJetBlock.selectedAddOns;
                  const quantity = selectedAddOns && selectedAddOns.count > 1 ? selectedAddOns.count : 1;
                  const addonNames = Array.from({length: quantity}, () => x.name);
                  return addonNames;
                }
                return [];
              })
              .toString()
          : '';
        reportParams.param10 = param10;
        report(reportParams);
        break;

      case 'movingBlock/report':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Moving';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber ?? '';
        reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
        reportParams.param1 = action.payload.products ?? '';
        reportParams.param2 = action.payload.param2 ?? '';
        reportParams.param3 = action.payload.selectedProducts ?? '';
        reportParams.param4 = action.payload.param4 ?? '';
        reportParams.param5 = action.payload.param5 ?? '';
        reportParams.param6 = action.payload.param6 ?? '';
        reportParams.param7 = action.payload.param7 ?? '';
        reportParams.param8 = action.payload.param8 ?? '';
        reportParams.param9 = action.payload.param9 ?? '';
        reportParams.param10 = action.payload.param10 ?? '';
        report(reportParams);
        break;

      case 'SalePackagesBlock/reportDWH':
        let salePackageEquipment = '';
        let saleType = state.saleJetBlock?.saleType ? state.saleJetBlock?.saleType : state.SalePackagesBlock.selectedPackage?.saleType;
        if (state.SalePackagesBlock.isCustomerSelectPackage) {
          salePackageEquipment = state.SalePackagesBlock.selectedPackage?.isSelectedCellcomRouter ? 'WITH EQUIPMENT' : 'WITHOUT EQUIPMENT';
        }

        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = getSaleType(saleType);
        reportParams.channel = 'Website';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName = '';
        reportParams.email = '';
        reportParams.idNumber = '';
        reportParams.subscriber = '';
        reportParams.param1 = state.SalePackagesBlock.selectedPackage?.offerID;
        reportParams.param2 = salePackageEquipment;
        report(reportParams);
        break;

      case 'contactUs/reportDWH':
        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = '';
        reportParams.channel = 'Website';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName = '';
        reportParams.email = '';
        reportParams.idNumber = '';
        reportParams.subscriber = '';
        reportParams.param1 = '';
        report(reportParams);
        break;
      case 'premiumPackagesCatalog/reportDWH':
        reportParams = getReportParams();
        const installedPackages = state.premiumPackagesCatalog?.installedPackages?.map((item, index) => {
          return item.cmsData?.selfCare?.title ? item.cmsData?.selfCare?.title : item.localizedName;
        });
        const subscriber = state.premiumPackagesCatalog.selectedSubscriber?.userTv
          ? [state.premiumPackagesCatalog.selectedSubscriber?.userTv]
          : state.premiumPackagesCatalog?.tvSubscribers?.map((item, index) => {
              return item.userTv;
            });
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'PremiumPackages';
        reportParams.channel = 'Website';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName =
          state.authentication?.loginData?.userDetails?.firstName + ' ' + state.authentication?.loginData?.userDetails?.lastName;
        reportParams.banId = state.premiumPackagesCatalog.selectedSubscriber?.ban;
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
        reportParams.cmrId = state.premiumPackagesCatalog.selectedSubscriber?.consumerId; //??
        reportParams.param1 = state.premiumPackagesCatalog.selectedPackagesDWH.join(', ');
        reportParams.param2 = state.premiumPackagesCatalog.totalPrice;
        reportParams.param3 = installedPackages.join(', ');
        reportParams.param4 = subscriber?.join(', ') || '';
        report(reportParams);
        break;
      case 'manufacturerWarrantyStatus/reportDWH':
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'ManufacturerWarrantyCheck';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.param1 = action.payload.IMEI ?? '';
        reportParams.param2 = action.payload.date ?? '';
        report(reportParams);
        break;
      case 'portal/reportDWH':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.channel = 'WebsiteBusiness';
        reportParams.subArea = action.payload.subArea;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.actionType = action.payload.actionType;

        reportParams.param1 = action.payload.param1 ?? '';
        reportParams.param2 = action.payload.param2 ?? '';
        reportParams.param3 = action.payload.param3 ?? '';
        reportParams.param4 = action.payload.param4 ?? '';
        reportParams.param10 = action.payload.param10 ?? '';
        reportParams.businessDetails = action.payload.businessDetails ?? '';
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
        reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber;
        reportParams.customerName =
          state.authentication?.loginData?.userDetails?.firstName + ' ' + state.authentication?.loginData?.userDetails?.lastName;
        report(reportParams);
        break;
      case 'dataWarehouseBlock/reportDWH':
        reportParams = getReportParams();
        reportParams.area = action.payload.area;
        reportParams.channel = action.payload.channel;
        reportParams.subArea = action.payload.subArea;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.actionType = action.payload.actionType;
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
        reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber;
        reportParams.customerName =
          state.authentication?.loginData?.userDetails?.firstName + ' ' + state.authentication?.loginData?.userDetails?.lastName;
        reportParams.param1 = window.location.origin + window.location.pathname;

        report(reportParams);
        break;
      case 'checkFiberInfrastructureBlock/reportDWH':
        let customerName = '';
        if (state.checkFiberInfrastructureBlock?.firstName && state.checkFiberInfrastructureBlock?.lastName) {
          customerName = state.checkFiberInfrastructureBlock?.firstName + ' ' + state.checkFiberInfrastructureBlock?.lastName;
        }
        let fullAddress = '';
        if (Object.keys(state.checkFiberInfrastructureBlock.addressPage.selectedAddress).length > 0) {
          fullAddress =
            state.checkFiberInfrastructureBlock.addressPage.selectedAddress.cityName +
            ' ' +
            state.checkFiberInfrastructureBlock.addressPage.selectedAddress.streetName +
            ' ' +
            state.checkFiberInfrastructureBlock.addressPage.selectedAddress.home;
        }

        reportParams = getReportParams();
        reportParams.area = 'Sale';
        reportParams.subArea = 'Checking Adress comp';
        reportParams.channel = 'Website';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName = customerName;
        reportParams.email = '';
        reportParams.idNumber = '';
        reportParams.subscriber = '';
        reportParams.param4 = fullAddress;
        reportParams.param5 = state.checkFiberInfrastructureBlock.personalInfo?.subscriberNo; //phone
        report(reportParams);
        break;
      case 'addonsBlock/reportDWH':
        let addonSubArea = '';
        let selectedService = state.addonsBlock.saleCatalog?.addons?.find((x) => x.name == state.addonsBlock.addonId);
        let selectedServiceDisplay = selectedService?.billDescription;

        let selectedSpeedDisplay = '';
        let primaryEmail = '';

        switch (state.addonsBlock.flowType) {
          case 'service':
            addonSubArea = 'Internet Services Sale';
            if (state.addonsBlock.addonId?.toUpperCase() == 'IPLOCK') {
              addonSubArea = 'PrivateIPAddress';
            }
            primaryEmail = state.addonsBlock.subscriber.primaryEmail;
            break;
          case 'mesh':
            addonSubArea = 'MESH Order';
            break;
          case 'internetSpeed':
            addonSubArea = 'Speed Upgrade';
            const customerSpeed = state.addonsBlock.saleCatalog.internetSpeedList?.find((x) => x.action == 'Existing');
            const selectedSpeed = state.addonsBlock.saleCatalog?.internetSpeedList?.find(
              (x) => x.name == state.addonsBlock.selectedSpeed.name,
            );
            selectedServiceDisplay = customerSpeed ? customerSpeed?.downloadSpeed + '/' + customerSpeed?.uploadSpeed : '';
            selectedSpeedDisplay = selectedSpeed ? selectedSpeed.downloadSpeed + '/' + selectedSpeed.uploadSpeed : '';
            break;
        }

        const meshCount = state.addonsBlock.selectedMeshList.length > 0 ? state.addonsBlock.selectedMeshList[0].count : '';
        const displayMoreSpeed = state.addonsBlock.isDisplayMoreSpeedLink ? 'הוצג קישור אני רוצה לשמוע על עוד מהירויות' : '';

        let paymentIssue = '';
        if (state.addonsBlock.subscriber.hasDebt && state.addonsBlock.subscriber.hasPaymentMethodIssue) {
          paymentIssue = 'hasDebt & hasPaymentIssue';
        } else {
          if (state.addonsBlock.subscriber.hasDebt) {
            paymentIssue = 'hasDebt';
          }
          if (state.addonsBlock.subscriber.hasPaymentMethodIssue) {
            paymentIssue = 'hasPaymentIssue';
          }
        }

        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = addonSubArea;
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName =
          state.authentication?.loginData?.userDetails?.firstName + ' ' + state.authentication?.loginData?.userDetails?.lastName;
        reportParams.email = primaryEmail;
        reportParams.banId = state.addonsBlock.subscriber.ban;
        reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
        reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber;
        reportParams.param1 = selectedServiceDisplay;
        reportParams.param2 = selectedSpeedDisplay;
        reportParams.param3 = meshCount;
        reportParams.param4 = displayMoreSpeed;
        reportParams.param5 = paymentIssue;
        reportParams.param6 = '';
        reportParams.param7 = '';
        reportParams.param8 = state.addonsBlock.technician?.selectedTechnicianTimeDisplay;
        reportParams.param9 = state.addonsBlock.errorDescription;
        reportParams.param10 = '';
        report(reportParams);
        break;
      case 'electricCompanyLeadBlock/reportDWH':
        let hasSmartCounter = '';
        const contractId = state.electricCompanyLeadBlock?.response?.contractId ?? '';
        const numberOfCounter = state.electricCompanyLeadBlock?.response?.currentConsumption ?? '';
        if (state.electricCompanyLeadBlock?.response?.serviceMigratable) {
          hasSmartCounter = state.electricCompanyLeadBlock?.response?.serviceMigratable == 'כן' ? 'Yes Smart Counter' : 'No Smart Counter';
        }
        reportParams.area = 'Sale';
        reportParams.subArea = 'EnergyBOT';
        reportParams.channel = 'Website';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.param1 = state.electricCompanyLeadBlock?.formDetails?.identityNumber;
        reportParams.param2 = state.electricCompanyLeadBlock?.formDetails?.phoneNumber;
        reportParams.param3 = state.electricCompanyLeadBlock?.formDetails?.fullName;
        reportParams.param4 = hasSmartCounter;
        reportParams.param5 = numberOfCounter; //number of Counter
        reportParams.param6 = contractId;
        report(reportParams);
        break;
      case 'esimUpgradeBlock/reportDWH':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'SIMtoESIM';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName = [
          state.esimUpgradeBlock?.checkUserResponse?.firstName || state.authentication?.loginData?.userDetails?.firstName,
          state.esimUpgradeBlock?.checkUserResponse?.lastName || state.authentication?.loginData?.userDetails?.lastName,
        ]
          .filter(Boolean)
          .join(' ');
        reportParams.email =
          state.esimUpgradeBlock?.checkUserResponse?.primaryEmail ||
          state.esimUpgradeBlock?.email ||
          state.authentication?.loginData?.userDetails?.CustomerEmail ||
          '';
        reportParams.banId = state.authentication?.loginData?.userDetails?.Ban || '';
        reportParams.idNumber =
          state.esimUpgradeBlock?.checkUserResponse?.idNumber || state.authentication?.loginData?.userDetails?.IDNumber || '';
        reportParams.subscriber = state.esimUpgradeBlock?.loginDetails?.subscriberNo;
        reportParams.cmrId = state.authentication?.loginData?.userDetails?.consumerId || '';
        reportParams.param1 = state.esimUpgradeBlock?.loginDetails?.subscriberNo;
        reportParams.param2 = '';
        reportParams.param3 = '';
        reportParams.param4 =
          action.payload.actionType === 'SuccessScreen' ? '' : state.esimUpgradeBlock?.esimPrice;
        reportParams.param5 = '';
        reportParams.param6 = '';
        reportParams.param7 = '';
        reportParams.param8 = '';
        reportParams.param9 = '';
        reportParams.param10 = '';
        report(reportParams);
        break;
      case 'esimQrCodeBlock/reportDWH':
        reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'eSIM Activation';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = action.payload.actionType;
        reportParams.status = action.payload.status;
        reportParams.messageText = action.payload.messageText;
        reportParams.customerName = [
          state.esimQrCodeBlock?.checkUserResponse?.firstName || state.authentication?.loginData?.userDetails?.firstName,
          state.esimQrCodeBlock?.checkUserResponse?.lastName || state.authentication?.loginData?.userDetails?.lastName,
        ]
          .filter(Boolean)
          .join(' ');
        reportParams.email =
          state.esimQrCodeBlock?.checkUserResponse?.primaryEmail ||
          state.esimQrCodeBlock?.email ||
          state.authentication?.loginData?.userDetails?.CustomerEmail ||
          '';
        reportParams.banId = state.authentication?.loginData?.userDetails?.Ban || '';
        reportParams.idNumber =
          state.esimQrCodeBlock?.checkUserResponse?.idNumber || state.authentication?.loginData?.userDetails?.IDNumber || '';
        reportParams.subscriber = state.esimQrCodeBlock?.loginDetails?.subscriberNo;
        reportParams.cmrId = state.authentication?.loginData?.userDetails?.consumerId || '';
        reportParams.param1 = state.esimQrCodeBlock?.loginDetails?.subscriberNo || '';
        reportParams.param2 = '';
        reportParams.param3 = '';
        reportParams.param4 = '';
        reportParams.param5 = '';
        reportParams.param6 = '';
        reportParams.param7 = '';
        reportParams.param8 = '';
        reportParams.param9 = '';
        reportParams.param10 = '';
        report(reportParams);
        break;
      case 'energySaleBlock/reportDWH':
                reportParams = getReportParams();
                let moneStatus = '';
                let numberOfMone = '';
                let numberOfContract = '';
                const selectedPackage = state.energySaleBlock.selectedPackage?.offerId ?? '';
                const energySaleFullAddress = state.energySaleBlock.userAddress.cityName ? state.energySaleBlock.userAddress.cityName + ',' + state.energySaleBlock.userAddress.streetName + ' ' + state.energySaleBlock.userAddress.home + ',' + state.energySaleBlock.userAddress.apartment : '';
                if (!(Object.keys(state.energySaleBlock.iecResponse).length === 0 && state.energySaleBlock.iecResponse.constructor === Object)) {
                    moneStatus = state.energySaleBlock.iecResponse?.serviceMigratable ? 'yes' : (!state.energySaleBlock.iecResponse?.serviceMigratable && state.energySaleBlock.iecResponse?.currentConsumption ? 'no' : 'no info');
                    if (state.energySaleBlock.iecResponse?.serviceMigratable) {
                        numberOfMone = state.energySaleBlock.iecResponse.currentConsumption;
                        numberOfContract = state.energySaleBlock.iecResponse.contractId;
                    }
                }
                reportParams.area = 'Sale';
                reportParams.subArea = 'EnergySale';
                reportParams.channel = 'Website';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.customerName = state.energySaleBlock.personalInfo.firstName + ' ' + state.energySaleBlock.personalInfo.lastName;
                reportParams.email = state.energySaleBlock.personalInfo.email;
                reportParams.idNumber = state.energySaleBlock.otpDetails.identityNumber;
                reportParams.param1 = state.energySaleBlock.otpDetails.identityNumber;
                reportParams.param2 = state.energySaleBlock.otpDetails.phoneNumber;
                reportParams.param3 = moneStatus;
                reportParams.param4 = numberOfMone;
                reportParams.param5 = numberOfContract;
                reportParams.param6 = selectedPackage;
                reportParams.param7 = state.energySaleBlock.personalInfo.firstName;
                reportParams.param8 = state.energySaleBlock.personalInfo.lastName;
                reportParams.param9 = energySaleFullAddress;
                reportParams.param10 = state.energySaleBlock.personalInfo.email;
                report(reportParams);
                break;
            case 'addonsAndUpgradesBlock/reportDWH':
                reportParams = getReportParams();
                reportParams.area = 'SelfCare';
                reportParams.subArea = 'My Zone';
                reportParams.channel = 'WebsitePrivate';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.customerName = state.authentication?.loginData?.userDetails?.firstName + ' ' + state.authentication?.loginData?.userDetails?.lastName;
                reportParams.email = '';
                reportParams.banId = state.selfcarePage?.selectedSubscriber?.ban;
                reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
                reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber;
                reportParams.param1 = state.selfcarePage?.selectedSubscriber?.productSubscriberNo;
                reportParams.param2 = state.selfcarePage?.selectedService?.selfCareCmsData?.title;
                reportParams.param3 = '';
                reportParams.param4 = '';
                reportParams.param5 = '';
                reportParams.param6 = '';
                reportParams.param7 = '';
                reportParams.param8 = '';
                reportParams.param9 = '';
                reportParams.param10 = state.authentication?.loginData?.isFullAuthenticated
                ? 'לקוח'
                : state.authentication?.loginData?.isOtpExtendedAuthenticated
                ? 'OTP מורחב'
                : state.authentication?.loginData?.isOtpAuthenticated
                ? 'OTP'
                : null;
                report(reportParams);
                break;
            case 'selfCareInvoiceBlock/reportDWH':
                reportParams = getReportParams();
                reportParams.area = 'SelfCare';
                reportParams.subArea = 'My Zone';
                reportParams.channel = 'WebsitePrivate';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
                reportParams.param1 = action.payload.param1;
                report(reportParams);
                break;
            case 'personalAreaInvoicesPage/reportDWH':
                function getUserPhones(allProductsInvoice) {
                  let userPhones = [];
                  allProductsInvoice?.allDetailsCliProduct?.forEach((product) => {
                    if (product.detailsType === 'CELLULAR' || product.detailsType === 'INTERNET') {
                      if( product.allDalDetailsCli.length > 1) {
                        product.allDalDetailsCli?.forEach((detail) => {
                          if (detail.userPhone) {
                            userPhones.push(detail.userPhone);
                          }
                        });
                      };
                    };
                  });
                  return userPhones.join(', ');
                };
                  reportParams = getReportParams();
                  reportParams.area = 'SelfCare';
                  reportParams.subArea = 'My Zone';
                  reportParams.channel = 'WebsitePrivate';
                  reportParams.actionType = action.payload.actionType;
                  reportParams.status = action.payload.status;
                  reportParams.subscriber = state.personalAreaInvoicesPage?.callsDetailsPage?.subscribers[0]?.userPhone;
                  reportParams.banId = reportParams.param1 = state.personalAreaInvoicesPage.selectedBan.ban ? `${state.personalAreaInvoicesPage.selectedBan.ban}` : '';
                  reportParams.messageText = action.payload.messageText;
                  reportParams.param1 = reportParams.param1 = state.personalAreaInvoicesPage.selectedBan.ban ? `${state.personalAreaInvoicesPage.selectedBan.ban}` : '';
                  reportParams.param2 = state.personalAreaInvoicesPage.invoicesInfo?.allProducts.allDetailsCliProduct?.map((item) => item.detailsType).join(', ');
                  reportParams.param3 = '';
                  reportParams.param4 =  state.personalAreaInvoicesPage.selectedBan.details.periodDate;
                  reportParams.param5 = state.personalAreaInvoicesPage.guidId;
                  reportParams.param6 =   state.authentication?.loginData.userDetails.IDNumber;
                  reportParams.param7 = reportParams.param7 = state.personalAreaInvoicesPage.guidId?.includes('NotC')
                  ? 'jet'
                  : state.authentication?.loginData?.isOtpExtendedAuthenticated || state.authentication?.loginData?.isFullAuthenticated
                  ? 'אזור אישי'
                  : 'SMS / EMAIL';
                  reportParams.param8 = null;
                  reportParams.param9 = 'מנוי איש קשר';
                  reportParams.param10 = loginType;
                  report(reportParams);
                  break;
            case 'zoneFaultBlock/reportDWH':
                    const zoneFaultBlock = state.zoneFaultBlock;
                    const isMagicLink =  zoneFaultBlock.isMagicLink ? 'הפעולה בוצעה על ידי ML' : '';
                    const zoneFaultStatus = zoneFaultBlock.zoneFaultStatus;
                    const statusMessage = zoneFaultStatus?.message || "";
                    const faultOrJobType = zoneFaultStatus?.faultOrJobType || "";
                    const endTime = zoneFaultStatus?.endDate && zoneFaultStatus?.endTime
                    ? `${zoneFaultStatus.endDate} - ${zoneFaultStatus.endTime}`
                    : zoneFaultStatus?.endDate || zoneFaultStatus?.endTime || "";

                    reportParams = getReportParams();
                    reportParams.area = 'SelfCare';
                    reportParams.subArea = 'RegionalFaultStatus';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType =  action.payload.actionType ?? 'Regional Fault Status Page';
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
                    reportParams.param1 = statusMessage;
                    reportParams.param2 = endTime;
                    reportParams.param3 = faultOrJobType;
                    reportParams.param4 = isMagicLink;
                    reportParams.banId = state.zoneFaultBlock?.selectedProduct?.ban;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
                    report(reportParams);
                    break;
            case 'serviceAppointmentSchedulerBlock/reportDWH':
                reportParams = getReportParams();
                reportParams.area = 'Support';
                reportParams.subArea = 'InternetFaultWizard';
                reportParams.channel = 'WebsitePrivate';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.param1 = action.payload.param1;
                reportParams.param2 =  state.serviceAppointmentSchedulerBlock.typePage;
                reportParams.param3 = action.payload.param3 ?? (state.serviceAppointmentSchedulerBlock.typePage === 'PERFORMED_TESTS_CONNECTION'
                ? 'Inernet Works Correctly'
                : state.serviceAppointmentSchedulerBlock.typePage === 'CONNECTION_NOT_CORRECT'
                    ? 'Technician Needed'
                    : '');
                reportParams.param4 = state.serviceAppointmentSchedulerBlock.delivery?.selectedDeliveryTimeDisplay;
                reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                reportParams.param10 = loginType;
                reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber;
                reportParams.banId = state.serviceAppointmentSchedulerBlock.subscriber?.ban;
                reportParams.subscriber =state.authentication?.loginData?.userDetails?.contactNumber;
                reportParams.psId = '';
                reportParams.cmrId= state.serviceAppointmentSchedulerBlock.subscriber?.consumerId;
                report(reportParams);
                break;
            case 'genericWizardBlock/reportDWH':
                reportParams = getReportParams();
                const genericWizardBlock = state.genericWizardBlock;
                const wizardName = genericWizardBlock.wizard.wizardName;
                const loginData = state.authentication?.loginData;
                const isAuthenticated = loginData?.isFullAuthenticated || loginData?.isOtpAuthenticated || loginData?.isOtpExtendedAuthenticated || loginData?.isSilentOtpAuthenticated;
                reportParams.area = 'Support';
                reportParams.subArea = 'SupportGuides';
                reportParams.channel = 'WebsitePrivate';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.param1 = wizardName;
                reportParams.param2 =  action.payload.title ?? '',
                reportParams.param9 = isAuthenticated ? (loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי') : ''
                reportParams.param10 = loginData?.isFullAuthenticated
                ? 'לקוח'
                : loginData?.isOtpExtendedAuthenticated
                ? 'OTP מורחב'
                : loginData?.isOtpAuthenticated
                ? 'OTP'
                : '';
                reportParams.customerName = `${loginData?.userDetails?.firstName} ${loginData?.userDetails?.lastName}`;
                reportParams.idNumber = loginData?.userDetails?.IDNumber ?? '';
                reportParams.subscriber = loginData?.userDetails?.contactNumber ?? '';
                report(reportParams);
                break;
            case 'tvActivationCodeRecoveryBlock/reportDWH':
                reportParams = getReportParams();
                reportParams.area = 'Support';
                reportParams.subArea = 'TVCode';
                reportParams.channel = 'WebsitePrivate';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                reportParams.param10 = loginType;
                reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                reportParams.banId = state.TvActivationCodeRecovery.selectedCustomer?.ban;
                reportParams.subscriber =state.authentication?.loginData?.userDetails?.contactNumber;
                reportParams.psId = '';
                reportParams.subscriber =
                reportParams.cmrId=
                report(reportParams);
                break;
            case 'equipmentListPage/reportDWH':
                let productName;
                switch (state.equipmentListPage?.epiData?.productType) {
                    case 1:
                        productName= 'נתב'
                        break;
                    case 3:
                        productName= 'מגדיל טווח'
                        break;
                    case 2:
                        productName= 'ממיר'
                        break;
                    default:
                };
                reportParams = getReportParams();
                reportParams.area = 'Support';
                reportParams.subArea = 'GeneralEquipment';
                reportParams.channel = 'WebsitePrivate';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.param1= productName;
                reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                reportParams.param10 = loginType;
                reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                reportParams.banId = state.authentication?.loginData?.userDetails.Ban;
                reportParams.subscriber = state.authentication?.loginData?.userDetails.contactNumber;
                reportParams.psId = '';
                reportParams.cmrId= ''
                report(reportParams);
                break;
            case 'equipmentMinePage/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'GeneralEquipment';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                    reportParams.param10 = loginType;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.banId = state.authentication?.loginData?.userDetails.Ban;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails.contactNumber;
                    reportParams.psId = '';
                    reportParams.cmrId= ''
                    report(reportParams);
                    break;
            case 'genericVasBlock/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'SelfCare';
                    reportParams.subArea = 'MabalChange';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails.contactNumber;
                    report(reportParams);
                    break;
            case 'localCellularTroubleshootingWizardBlock/reportDWH':

                    const selectedSubscriber = state.localCellularTroubleshootingWizardBlock?.subscriber;
                    const banId = state.localCellularTroubleshootingWizardBlock?.ban;

                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'SupportGuides';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
                    reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber ?? '';
                    reportParams.banId = banId ?? '';
                    reportParams.param1= action.payload.param1 ?? '';
                    reportParams.param2= selectedSubscriber ?? '';
                    report(reportParams);
                    break;
                     case 'wifiManagementBlock/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'WifiConfiguration';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
                    reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber ?? '';
                    reportParams.banId = state.wifiManagementBlock?.subscriber?.ban ?? '';
                    reportParams.param1 = action.payload.param1 ?? '';
                    reportParams.param2 = state.wifiManagementBlock?.subscriber?.contactNumber ?? '';
                    reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                    reportParams.param10 = loginType;
                    report(reportParams);
                    break;
                case 'energyReplaceBlock/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'ElectricalPlanTransition';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
                    reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber ?? '';
                    reportParams.param1 =action.payload.param1 ?? String(state.energyReplaceBlock?.subscriber?.subscriberNo ?? '');
                    reportParams.param2 =
                        action.payload.param2 ??
                        (state.energyReplaceBlock?.selectedPackage?.offerID != null
                            ? String(state.energyReplaceBlock.selectedPackage.offerID)
                            : '');
                    report(reportParams);
                    break;
            case 'problemDomainBlock/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'SupportCenterMalfunctionFlow';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.param1 = action.payload.param1;
                    reportParams.param2 = action.payload.param2;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
                    reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber ?? '';
                    report(reportParams);
                    break;
            case 'collectionPointsBlock/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'InternetFaultWizard';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.param1 = action.payload.param1;
                    reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                    reportParams.param10 = loginType;
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.banId = state.serviceAppointmentSchedulerBlock?.subscriber?.ban;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber;
                    reportParams.cmrId = state.serviceAppointmentSchedulerBlock?.subscriber?.consumerId;
                    report(reportParams);
                    break;
            case 'guidesBlock/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'SupportCenterMalfunctionFlow';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.param1 = action.payload.param1;//Chosen Product Name (Cellular/TV/Fiber/Abroad)
                    reportParams.param3 = action.payload.param3;//שם תקלה שעליה לחץ
                    reportParams.param4 = action.payload.param4;//שם המדריך שלחץ עליו
                    reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
                    reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber ?? '';
                    reportParams.banId = '';
                    report(reportParams);
                    break;
            case 'operationsAreasBlock/reportDWH':
                    reportParams = getReportParams();
                    reportParams.area = 'Support';
                    reportParams.subArea = 'SupportCenterActionFlow';
                    reportParams.channel = 'WebsitePrivate';
                    reportParams.actionType = action.payload.actionType;
                    reportParams.status = action.payload.status;
                    reportParams.messageText = action.payload.messageText;
                    reportParams.param1 = action.payload.param1 ?? '';
                    reportParams.param3 = action.payload.param3 ?? '';
                    reportParams.param9 = state.authentication?.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי';
                    reportParams.customerName = `${state.authentication?.loginData?.userDetails?.firstName} ${state.authentication?.loginData?.userDetails?.lastName}`;
                    reportParams.banId = "";
                    reportParams.idNumber = state.authentication?.loginData?.userDetails?.IDNumber ?? '';
                    reportParams.subscriber = state.authentication?.loginData?.userDetails?.contactNumber ?? '';
                    report(reportParams);
                    break;
            case 'serviceEntryBlock/reportDWH':
                reportParams = getReportParams();
                const serviceEntryLoginData = state.authentication?.loginData;
                const isServiceEntryAuthenticated = serviceEntryLoginData?.isFullAuthenticated || serviceEntryLoginData?.isOtpAuthenticated || serviceEntryLoginData?.isOtpExtendedAuthenticated || serviceEntryLoginData?.isSilentOtpAuthenticated;
                reportParams.area = 'Support';
                reportParams.subArea = 'SupportCenterLobby';
                reportParams.channel = 'WebsitePrivate';
                reportParams.actionType = action.payload.actionType;
                reportParams.status = action.payload.status;
                reportParams.messageText = action.payload.messageText;
                reportParams.customerName = isServiceEntryAuthenticated ? `${serviceEntryLoginData?.userDetails?.firstName} ${serviceEntryLoginData?.userDetails?.lastName}` : '';
                reportParams.idNumber = serviceEntryLoginData?.userDetails?.IDNumber ?? '';
                reportParams.subscriber = serviceEntryLoginData?.userDetails?.contactNumber ?? '';
                reportParams.param1 = action.payload.param1 ?? '';
                reportParams.param9 = isServiceEntryAuthenticated ? (serviceEntryLoginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי') : '';
                reportParams.param10 = loginType;
                report(reportParams);
                break;
        }
    } catch (error) {
    }

  return next(action);
};

//-------------------------------------
export function getReportParams() {
  const reportParams = {
    //required
    area: '',
    subArea: '',
    channel: '',
    actionType: '',
    status: '', //Ongoing | Completed | Error
    messageText: '',

    //optional
    customerName: '',
    email: '',
    banId: '',
    psId: '',
    idNumber: '',
    subscriber: '',
    cmrId: '',
    param1: '',
    param2: '',
    param3: '',
    param4: '',
    param5: '',
    param6: '',
    param7: '',
    param8: '',
    param9: '',
    param10: '',
    businessDetails: '',
  };

  return reportParams;
}

function getSaleType(saleType) {
  switch (saleType) {
    case 'tv':
      return 'TV';
    case 'app':
      return 'TVApp';
    case 'cellular':
      return 'Cellular';
    case 'internet':
      return 'Fiber';
    case 'triple':
      return 'FiberTV';
    case 'energy':
      return 'EnergySale';
    default:
      return 'NA';
  }
}

function hasProducts(saleJetBlock) {
  let hasEquipment = false;

  try {
    const converters = saleJetBlock.saleCatalog.converters ? saleJetBlock.saleCatalog.converters.filter((x) => x.action == 'Add') : [];
    const routers = saleJetBlock.saleCatalog.routers
      ? saleJetBlock.saleCatalog.routers.filter((x) => x.action == 'Add' && !x.isForeignRouter)
      : [];
    const superWifiList = saleJetBlock.saleCatalog.superWifiList
      ? saleJetBlock.saleCatalog.superWifiList.filter((x) => x.action == 'Add')
      : [];
    hasEquipment = converters.length > 0 || routers.length > 0 || superWifiList.length > 0;
  } catch (error) {
    console.error(error);
  }

  return hasEquipment;
}

function getPremiumPackages(saleJetBlock) {
  let premiumPackages = [];

  try {
    saleJetBlock.saleCatalog?.premiumPackages?.map(function (item) {
      if (item.action == 'Add') {
        premiumPackages.push(item.billDescription);
      }

      item.vasList?.map(function (vas) {
        if (vas.action == 'Add') {
          premiumPackages.push(vas.billDescription);
        }
      });
    });
  } catch (error) {
    console.error(error);
  }

  return premiumPackages.join(',');
}

export function report(reportParams) {

if( !isNullOrEmpty(reportParams.businessDetails) ) {
  const state = EpiContext.getStore().getState();
  reportParams.businessDetails = {...reportParams.businessDetails, _orgId: state.portalsBlock?.selectedHetPayId , _companyNumber: state.portalsBlock?.selectedHetPay };
}

  const reportItem = {
    eReportingType: 3,
    reportItem: reportParams,
  }

  ProviderManager.getProviderData('report', reportItem);
}

//-------------------------------------

export default reportMiddleware;
